import script from "./kaochangfeitongyi.vue?vue&type=script&setup=true&lang=js"
export * from "./kaochangfeitongyi.vue?vue&type=script&setup=true&lang=js"

import "./kaochangfeitongyi.vue?vue&type=style&index=0&id=1e3d4d10&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e3d4d10"]])

export default __exports__